import { useCallback, useEffect, useMemo } from 'react';

import StatCard from '../../components/stats/StatCard';
import StatLoader from './StatLoader';

import { useAppDispatch, useAppSelector } from '../../store/hooks';

import { getRenewalStats } from '../../store/stats/stats-slice';

interface RenewalProps {
  propertyID: string;
}

const defaultData = {
  title: 'Renewals',
  barData: {
    value: 0,
    total: 0
  },
  topData: {
    label: 'YTD Goal',
    value: 0
  },
  bottomData: {
    label: 'YTD Variance',
    value: 0
  }
};

const Renewal = ({ propertyID }: RenewalProps): React.ReactElement | null => {
  const dispatch = useAppDispatch();
  const renewals: any = useAppSelector((state) => state.stats?.renewals);
  // console.log('renewals:', renewals);

  const selectedPropertyData = useMemo(() => {
    if (
      !renewals ||
      renewals.isLoading ||
      !renewals.data ||
      renewals.data.length === 0
    ) {
      return defaultData;
    }

    if (
      !propertyID &&
      !renewals.isLoading &&
      renewals?.data &&
      renewals?.data?.length > 0
    ) {
      return defaultData;
    }

    const selectedData = renewals?.data?.find(
      (property: any) => property.propertyId === propertyID
    );

    if (!selectedData) {
      return defaultData;
    }

    return {
      title: "Renewals",
      barData: {
        value: renewals?.data?.[0]?.ytd_renewed_actual ?? 0,
        total: renewals?.data?.[0]?.full_year_renewal_goal ?? 0
      },
      topData: {
        label: "YTD Goal",
        value:  renewals?.data?.[0]?.ytd_renewal_goal ?? 0,
      },
      bottomData: {
        label: "YTD Variance",
        value: 
          Number(renewals?.data?.[0]?.ytd_renewed_actual ?? 0) -
          Number(renewals?.data?.[0]?.ytd_renewal_goal ?? 0),
      },
    };
  }, [propertyID, renewals]);

  const fetchData = useCallback(async () => {
    try {
      if (!propertyID) {
        return;
      }

      await dispatch(getRenewalStats(propertyID));
    } catch (error) {
      console.log('error:', error);
    }
  }, [dispatch, propertyID]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <>
      <StatLoader isLoading={renewals?.isLoading} />
      <StatCard
        data={selectedPropertyData ? selectedPropertyData : defaultData}
      />
    </>
  );
};

export default Renewal;
